import Axios from "axios";

export {
    actionsQnAmaker,
    blobStorage,
    whatsAppCampaignActions,
    authActions,
    intebotDataActions,
    actionsPLNManagement,
    getDirectLineToken,
    reconnectToConversation,
    openAIActions,
    actionsPowerBi,
    getCampaignList,
    getCampaignCatalogs,
    checkCampaignName,
    getCampaignToken,
    createCampaign,
    activateCampaign,
    deactivateCampaign,
    deleteCampaign,
    updateCampaignSchedule,
    previewSegment,
    getWhatsAppContacts,
    createWhatsAppContact,
    updateWhatsAppContact,
    deleteWhatsAppContacts,
    importWhatsAppContacts,
    getTickets,
    updateTicket,
    sendTicketResolvedNotification,
};

//Centralized INTEBOT DATA
async function intebotDataActions(data, type, apiFunction) {
    if (!apiFunction) throw new Error("You must specify an apiFunction for this function");
    let code = "";

    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const coreResourceServiceKey = remeberAuthCredentials
        ? localStorage.getItem("coreResourceServiceKey")
        : sessionStorage.getItem("coreResourceServiceKey");
    switch (apiFunction) {
        //Flows
        case "BotConfigurationOperations":
            code = process.env.REACT_APP_BOT_CONFIGURATION_CODE;
            break;
        case "ModelConfigurationOperations":
            code = process.env.REACT_APP_MODEL_CONFIGURATION_CODE;
            break;
        default:
            throw new Error("There is no code for this api call");
    }
    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_INTEBOT_DATA_ENDPOINT}${apiFunction}?code=${code}&type=${type}`,
            data: JSON.stringify(data, null, 2),
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: coreResourceServiceKey,
            },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log(`Response in ${type}`, res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log(`Catch error in ${type}`, error);
        return error;
    }
}

//QnAmaker Actions
async function actionsQnAmaker(data, type) {
    if (!type) throw new Error("You must specify an type for this function ");
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const coreResourceServiceKey = remeberAuthCredentials
        ? localStorage.getItem("coreResourceServiceKey")
        : sessionStorage.getItem("coreResourceServiceKey");
    try {
        let axiosObj = {
            url: `${process.env.REACT_APP_QNA_MAKER_URLWS}&type=${type}`,
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: coreResourceServiceKey,
            },
        };
        if (data) axiosObj.data = JSON.stringify(data, null, 2);
        let res = await Axios(axiosObj);
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in actionsQnAmaker", res);

        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Catch error in actionsQnAmaker", error);
        return error;
    }
}

//Authentication Actions
async function authActions(data, type, apiFunction) {
    // console.log('data', data)
    // console.log('type :>> ', type);
    // console.log('apiFunction', apiFunction)

    if (!apiFunction) throw new Error("You must specify an apiFunction for this function");

    let code = "";
    let endPoint = process.env.REACT_APP_AUTH_ACTIONS_ENDPOINT;
    let Authorization = process.env.REACT_APP_AUTHORIZATION_TOKEN;

    let remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    let serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");
    let authToken = remeberAuthCredentials
        ? localStorage.getItem("token")
        : sessionStorage.getItem("token");
    switch (apiFunction) {
        case "LogIn":
            code = process.env.REACT_APP_LOGIN_CODE;
            if (type === "ValidateTokenRole") {
                type = `ValidateTokenRole&token=${authToken}`;
            }
            break;
        case "SignUp":
            code = process.env.REACT_APP_SIGNUP_CODE;
            break;
        case "PasswordReset":
            code = process.env.REACT_APP_PASSWORD_RESET_CODE;
            break;
        case "SubscriptionOperations":
            code = process.env.REACT_APP_SUBSCRIPTION_OP_CODE;
            break;
        case "RoleManagement":
            code = process.env.REACT_APP_ROLE_MANAGEMENT_CODE;
            break;
        default:
            throw new Error("There is no code for this api call " + apiFunction);
    }

    try {
        let res = await Axios({
            url: `${endPoint}${apiFunction}?code=${code}&type=${type}`,
            data: JSON.stringify(data, null, 2),
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                Authorization: Authorization,
                "Content-Type": "application/json",
            },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in authActions", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in authActions", error);
        return error;
    }
}

//WhatsApp Campaigns Actions
async function whatsAppCampaignActions(data, type, isSendCampaign) {
    // Las operaciones sobre plantillas migraron a un esquema REST con token.
    // Se enrutan a templateActions manteniendo la misma firma y formato de respuesta.
    const templateTypes = ["getTemplateList", "createTemplate", "deleteTemplate", "updateUrlTemplate", "getRateLimit"];
    if (!isSendCampaign && templateTypes.includes(type)) {
        return templateActions(data, type);
    }

    // El envío de mensajes (sendMessage) ahora usa el mismo esquema de token
    // que plantillas y campañas: Authorization = token, x-access-key = serviceKey.
    if (isSendCampaign) {
        return sendMessageActions(data);
    }

    try {
        let remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
        let serviceKey = remeberAuthCredentials
            ? localStorage.getItem("serviceKey")
            : sessionStorage.getItem("serviceKey");

        let urlWS = process.env.REACT_APP_MANAGE_WHATSAPP_CAMPAIGNS_URLWS;

        let res = await Axios({
            url: `${urlWS}&type=${type}`,
            data: JSON.stringify(data, null, 2),
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                Authorization: serviceKey,
                "Content-Type": "application/json",
            },
        });
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Response in whatsAppCampaignActions", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Catch error in whatsAppCampaignActions", error);
        return error;
    }
}

//WhatsApp Send Message (esquema REST con token)
// - Autenticación: Authorization = token, x-access-key = serviceKey
// - POST al endpoint de envío de campañas
async function sendMessageActions(data) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_SEND_WHATSAPP_CAMPAIGNS_URLWS}`,
            data: JSON.stringify(data, null, 2),
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
        });
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Response in sendMessageActions", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Catch error in sendMessageActions", error);
        return error;
    }
}

//WhatsApp Templates Actions (esquema REST con token)
// - Autenticación: Authorization = token, x-access-key = serviceKey
// - Métodos por operación:
//   getTemplateList  -> GET    /api/templates        (sin body)
//   createTemplate   -> POST   /api/templates        (body: { templateName, templateContent, header?, buttons? })
//   deleteTemplate   -> DELETE /api/templates        (body: { templateName })
//   updateUrlTemplate-> PATCH  /api/templates        (body: { templateName, url })
//   getRateLimit     -> GET    /api/templates/rate-limit  (sin body)
// El formato de respuesta { response: { code, ... } } no cambia.
async function templateActions(data, type) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    const baseUrl = process.env.REACT_APP_TEMPLATES_ENDPOINT;
    if (!baseUrl) {
        console.error("templateActions: REACT_APP_TEMPLATES_ENDPOINT no está definida. Reinicia el servidor de desarrollo si acabas de agregar la variable al .env");
        return { error: "REACT_APP_TEMPLATES_ENDPOINT not defined" };
    }

    // Resolver método HTTP y URL según la operación
    let method = "GET";
    let url = baseUrl;
    let sendBody = false;
    switch (type) {
        case "getTemplateList":
            method = "GET";
            sendBody = false;
            break;
        case "createTemplate":
            method = "POST";
            sendBody = true;
            break;
        case "deleteTemplate":
            method = "DELETE";
            sendBody = true;
            break;
        case "updateUrlTemplate":
            method = "PATCH";
            sendBody = true;
            break;
        case "getRateLimit":
            method = "GET";
            sendBody = false;
            // Construir URL de rate-limit
            url = baseUrl.endsWith("/")
                ? `${baseUrl}rate-limit`
                : `${baseUrl}/rate-limit`;
            break;
        default:
            break;
    }

    try {
        let axiosObj = {
            url,
            method,
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
        };
        if (sendBody && data) {
            axiosObj.data = JSON.stringify(data, null, 2);
        }
        let res = await Axios(axiosObj);
        process.env.REACT_APP_DEBUG === "true" &&
            console.log(`Response in templateActions (${type})`, res);
        if (type === "getTemplateList") {
            // Log temporal para diagnosticar estructura del nuevo endpoint
            const rawData = res?.data;
            const firstTemplate = Array.isArray(rawData) ? rawData[0]
                : rawData?.templateList?.[0] || rawData?.templates?.[0];
            console.log("templateActions getTemplateList — first template raw:", JSON.stringify(firstTemplate));
        }

        // Normalizar respuesta al formato legacy { response: { code, ... } }
        // para que los call sites no necesiten cambios.
        if (res?.data && !res.data.response) {
            // La API nueva puede devolver { code, message, ... } directamente
            // o en caso de éxito solo un 200 sin body de code.
            if (res.data.code !== undefined) {
                // Hay código directo en data
                res = { ...res, data: { response: res.data } };
            } else if (res.status === 200 || res.status === 201) {
                // 200 sin código → mapear al código de éxito de cada operación
                const successCodeMap = {
                    createTemplate:    "07",
                    deleteTemplate:    "08",
                    updateUrlTemplate: "05",
                    getTemplateList:   "05",
                    getRateLimit:      "0",
                };
                const successCode = successCodeMap[type] || "0";
                res = { ...res, data: { response: { code: successCode, templateList: res.data?.templateList || res.data?.templates || res.data } } };
            }
        }

        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" &&
            console.log(`Catch error in templateActions (${type})`, error);
        return error;
    }
}

//send files or Delete files to blob storage
async function blobStorage(data, type) {
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const coreResourceServiceKey = remeberAuthCredentials
        ? localStorage.getItem("coreResourceServiceKey")
        : sessionStorage.getItem("coreResourceServiceKey");
    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_BLOB_STORAGE_URLWS}&type=${type}`,
            data: JSON.stringify(data, null, 2),
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: coreResourceServiceKey,
            },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in blobStorage", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in blobStorage", error);
    }
}

async function actionsPLNManagement(data, type) {
    if (!type) throw new Error("You must specify an type for this function");
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const coreResourceServiceKey = remeberAuthCredentials
        ? localStorage.getItem("coreResourceServiceKey")
        : sessionStorage.getItem("coreResourceServiceKey");
    try {
        let axiosObj = {
            url: `${process.env.REACT_APP_PLN_MANAGEMENT_URLWS}&type=${type}`,
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: coreResourceServiceKey,
            },
        };
        if (data) axiosObj.data = JSON.stringify(data, null, 2);
        let res = await Axios(axiosObj);
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Response in actionsPLNManagement, type", res, type);

        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Catch error in actionsPLNManagement", error);
        return error;
    }
}

async function getDirectLineToken(data) {
    try {
        let axiosObj = {
            url: `https://directline.botframework.com/v3/directline/tokens/generate`,
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${data}`,
            },
        };
        let res = await Axios(axiosObj);
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Response in getDirectLineToken", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Catch error in getDirectLineToken", error);
        return error;
    }
}

async function reconnectToConversation(conversationId, token, watermark) {
    try {
        let axiosObj = {
            url: `https://directline.botframework.com/v3/directline/conversations/${conversationId}/?watermark=${watermark}`,
            method: "GET",
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        let res = await Axios(axiosObj);
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Response in reconnectToConversation", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Catch error in reconnectToConversation", error);
        return error;
    }
}

async function openAIActions(data, type) {
    if (!type) throw new Error("You must specify an type for this function");
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const coreResourceServiceKey = remeberAuthCredentials
        ? localStorage.getItem("coreResourceServiceKey")
        : sessionStorage.getItem("coreResourceServiceKey");
    try {
        let axiosObj = {
            url: `${process.env.REACT_APP_OPENAI_URLWS}&type=${type}`,
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: coreResourceServiceKey,
            },
        };
        if (data) axiosObj.data = JSON.stringify(data, null, 2);
        let res = await Axios(axiosObj);
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Response in openAIActions, type", res, type);

        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Catch error in openAIActions", error);
        return error;
    }
}

async function actionsPowerBi(data) {
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const reportServiceKey = remeberAuthCredentials
        ? localStorage.getItem("reportServiceKey")
        : sessionStorage.getItem("reportServiceKey");
    try {
        let axiosObj = {
            url: `${process.env.REACT_APP_POWER_BI_URLWS}`,
            method: "POST",
            timeout: 3000000, //5 minutos
            headers: {
                "Content-Type": "application/json",
                Authorization: reportServiceKey,
            },
        };
        if (data) axiosObj.data = JSON.stringify(data, null, 2);
        let res = await Axios(axiosObj);
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Response in actionsPowerBi, type", res);

        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" &&
            console.log("Catch error in actionsPowerBi", error);
        return error;
    }
}


//Campaign Auth Token
async function getCampaignToken() {
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");
    const currentSubscription = remeberAuthCredentials
        ? JSON.parse(localStorage.getItem("currentSubscription"))
        : JSON.parse(sessionStorage.getItem("currentSubscription"));
    const subscriptionId = currentSubscription?.subscriptionId || "";
    const subscriptionServiceKey = remeberAuthCredentials
        ? localStorage.getItem("coreResourceServiceKey")
        : sessionStorage.getItem("coreResourceServiceKey");

    console.log("=== getCampaignToken REQUEST ===");
    console.log("URL:", process.env.REACT_APP_CAMPAIGNS_TOKEN_ENDPOINT);
    console.log("subscriptionId:", subscriptionId);
    console.log("apiKey (subscription serviceKey):", subscriptionServiceKey);
    console.log("scope:", "SendCampaigns");
    console.log("================================");

    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_CAMPAIGNS_TOKEN_ENDPOINT}`,
            method: "POST",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
            },
            data: JSON.stringify({
                subscriptionId: subscriptionId,
                apiKey: subscriptionServiceKey,
                scope: "SendCampaigns",
            }),
        });
        console.log("getCampaignToken RESPONSE:", res?.data);
        return res?.data?.access_token || null;
    } catch (error) {
        console.log("getCampaignToken ERROR:", error?.response?.data || error.message);
        return null;
    }
}

//Campaign List Actions
async function getCampaignList() {
    const token = await getCampaignToken();
    if (!token) {
        console.log("Error: No se pudo obtener el token de campañas");
        return { error: "No token" };
    }
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    console.log("=== getCampaignList REQUEST ===");
    console.log("URL:", process.env.REACT_APP_CAMPAIGNS_ENDPOINT);
    console.log("Authorization:", token);
    console.log("x-access-key:", serviceKey);
    console.log("==============================");

    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_CAMPAIGNS_ENDPOINT}`,
            method: "GET",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in getCampaignList", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in getCampaignList", error);
        return error;
    }
}

//Check Campaign Name Availability
async function checkCampaignName(name) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_CAMPAIGNS_CHECK_NAME_ENDPOINT}?name=${encodeURIComponent(name)}`,
            method: "GET",
            timeout: 10000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in checkCampaignName", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in checkCampaignName", error);
        return error;
    }
}

//Campaign Catalogs Actions
async function getCampaignCatalogs() {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_CAMPAIGNS_CATALOGS_ENDPOINT}`,
            method: "GET",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in getCampaignCatalogs", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in getCampaignCatalogs", error);
        return error;
    }
}

//Create Campaign
async function createCampaign(campaignData) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_CAMPAIGNS_ENDPOINT}`,
            method: "POST",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: campaignData,
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in createCampaign", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in createCampaign", error);
        return error;
    }
}

//Activate Campaign
async function activateCampaign(campaignId) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_CAMPAIGNS_ENDPOINT_BASE}/activate`,
            method: "PUT",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: { campaignId },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in activateCampaign", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in activateCampaign", error);
        return error;
    }
}

//Deactivate Campaign
async function deactivateCampaign(campaignId) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    try {
        const url = `${process.env.REACT_APP_CAMPAIGNS_ENDPOINT_BASE}/deactivate`;
        console.log("=== deactivateCampaign ===");
        console.log("URL:", url);
        console.log("Body:", { campaignId });
        console.log("Authorization:", token);
        console.log("x-access-key:", serviceKey);
        let res = await Axios({
            url: url,
            method: "PUT",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: { campaignId },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in deactivateCampaign", res);
        return res;
    } catch (error) {
        console.log("Catch error in deactivateCampaign", error?.response?.status, error?.response?.data);
        return error;
    }
}

//Delete Campaign
async function deleteCampaign(campaignId) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_CAMPAIGNS_ENDPOINT}`,
            method: "DELETE",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: { campaignId },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in deleteCampaign", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in deleteCampaign", error);
        return error;
    }
}

//Update Campaign Schedule
async function updateCampaignSchedule(campaignId, schedule) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    try {
        let res = await Axios({
            url: `${process.env.REACT_APP_CAMPAIGNS_ENDPOINT}`,
            method: "PATCH",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: { campaignId, schedule },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in updateCampaignSchedule", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in updateCampaignSchedule", error);
        return error;
    }
}

//Preview Segment
async function previewSegment(segments, page, pageSize, interactions, lastModified) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    try {
        const requestData = { segments: segments || [], page: page || 1, pageSize: pageSize || 100 };
        if (interactions) requestData.interactions = interactions;
        if (lastModified) requestData.lastModified = lastModified;
        const url = `${process.env.REACT_APP_CAMPAIGNS_ENDPOINT_BASE}/preview-segment`;
        process.env.REACT_APP_DEBUG === "true" && console.log("previewSegment REQUEST ===");
        process.env.REACT_APP_DEBUG === "true" && console.log("URL:", url);
        process.env.REACT_APP_DEBUG === "true" && console.log("data:", JSON.stringify(requestData));
        let res = await Axios({
            url,
            method: "POST",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: requestData,
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in previewSegment", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in previewSegment", error);
        process.env.REACT_APP_DEBUG === "true" && console.log("previewSegment error response:", error?.response?.data);
        return error;
    }
}

//WhatsApp Contacts List (esquema REST con token)
// - Autenticación: Authorization = token (getCampaignToken), x-access-key = serviceKey
// - GET al endpoint de contactos de WhatsApp
async function getWhatsAppContacts() {
    const token = await getCampaignToken();
    if (!token) {
        console.log("Error: No se pudo obtener el token para contactos");
        return { error: "No token" };
    }
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const serviceKey = remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");

    const url = process.env.REACT_APP_CONTACTS_ENDPOINT;
    if (!url) {
        console.error("getWhatsAppContacts: REACT_APP_CONTACTS_ENDPOINT no está definida. Reinicia el servidor de desarrollo si acabas de agregar la variable al .env");
        return { error: "REACT_APP_CONTACTS_ENDPOINT not defined" };
    }

    try {
        let res = await Axios({
            url: `${url}`,
            method: "GET",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in getWhatsAppContacts", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in getWhatsAppContacts", error);
        return error;
    }
}

// Helper interno: obtiene el serviceKey del storage según "recordar credenciales".
function getStoredServiceKey() {
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    return remeberAuthCredentials
        ? localStorage.getItem("serviceKey")
        : sessionStorage.getItem("serviceKey");
}

//Create WhatsApp Contact (esquema REST con token)
// - POST /whatsapp/contacts con el payload { contacts: [ { ... } ] }
//   Campos del contacto: phone_number, name, gender ("F"|"M"), age, state,
//   locality, interests (array), sentiment, origin ("Portal" por defecto).
async function createWhatsAppContact(contact) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const serviceKey = getStoredServiceKey();
    const url = process.env.REACT_APP_CONTACTS_ENDPOINT;
    if (!url) return { error: "REACT_APP_CONTACTS_ENDPOINT not defined" };

    // El servicio espera los contactos dentro de un arreglo "contacts".
    // Aseguramos el origen por defecto.
    const contactWithOrigin = { origin: "Portal", ...contact };
    const payload = { contacts: [contactWithOrigin] };

    try {
        let res = await Axios({
            url: `${url}`,
            method: "POST",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: JSON.stringify(payload),
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in createWhatsAppContact", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in createWhatsAppContact", error);
        return error;
    }
}

//Update WhatsApp Contact (esquema REST con token)
// - PATCH /whatsapp/contacts con el payload { contacts: [ { ... } ] }
//   Se envían SOLO los campos que el usuario modificó, siempre acompañados
//   del phone_number, que es el identificador del contacto.
async function updateWhatsAppContact(contact) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const serviceKey = getStoredServiceKey();
    const url = process.env.REACT_APP_CONTACTS_ENDPOINT;
    if (!url) return { error: "REACT_APP_CONTACTS_ENDPOINT not defined" };

    // El objeto `contact` ya viene con el phone_number + solo los campos
    // modificados (el DIFF lo arma ContactEditSection).
    const payload = { contacts: [contact] };

    try {
        let res = await Axios({
            url: `${url}`,
            method: "PATCH",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: JSON.stringify(payload),
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in updateWhatsAppContact", res);
        return res;
    } catch (error) {
        // Log del detalle del error para diagnosticar el rechazo del backend.
        if (process.env.REACT_APP_DEBUG === "true") {
            console.log("Catch error in updateWhatsAppContact", error);
            console.log("updateWhatsAppContact status:", error?.response?.status);
            console.log("updateWhatsAppContact body:", JSON.stringify(error?.response?.data));
            console.log("updateWhatsAppContact payload enviado:", JSON.stringify(payload));
        }
        return error;
    }
}

//Delete WhatsApp Contacts (soporta uno o varios)
// - DELETE /whatsapp/contacts con { phone_numbers: [ ... ] }
async function deleteWhatsAppContacts(phoneNumbers) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const serviceKey = getStoredServiceKey();
    const url = process.env.REACT_APP_CONTACTS_ENDPOINT;
    if (!url) return { error: "REACT_APP_CONTACTS_ENDPOINT not defined" };

    const list = Array.isArray(phoneNumbers) ? phoneNumbers : [phoneNumbers];

    try {
        let res = await Axios({
            url: `${url}`,
            method: "DELETE",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: JSON.stringify({ phone_numbers: list }),
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in deleteWhatsAppContacts", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in deleteWhatsAppContacts", error);
        return error;
    }
}

//Import WhatsApp Contacts (importación masiva)
// El portal lee el CSV en el navegador y lo convierte a un arreglo de
// contactos; aquí solo se envía ese arreglo al MISMO endpoint de agregar
// contacto (POST /whatsapp/contacts) con el payload { contacts: [ ... ] },
// igual que createWhatsAppContact pero con varios contactos a la vez.
// - contactsArray: [ { phone_number, name, gender, age, interests: [...], ... }, ... ]
async function importWhatsAppContacts(contactsArray) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const serviceKey = getStoredServiceKey();
    const url = process.env.REACT_APP_CONTACTS_ENDPOINT;
    if (!url) return { error: "REACT_APP_CONTACTS_ENDPOINT not defined" };

    const list = Array.isArray(contactsArray) ? contactsArray : [];
    if (list.length === 0) return { error: "No contacts to import" };

    // Aseguramos el origen por defecto en cada contacto (igual que al crear uno).
    const contacts = list.map((contact) => ({ origin: "Portal", ...contact }));
    const payload = { contacts };

    try {
        let res = await Axios({
            url: `${url}`,
            method: "POST",
            timeout: 120000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: JSON.stringify(payload),
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in importWhatsAppContacts", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in importWhatsAppContacts", error);
        return error;
    }
}

//Tickets List (esquema REST con token)
// - Autenticación: Authorization = token (getCampaignToken), x-access-key = serviceKey
// - GET al endpoint de tickets
async function getTickets() {
    const token = await getCampaignToken();
    if (!token) {
        console.log("Error: No se pudo obtener el token para tickets");
        return { error: "No token" };
    }
    const serviceKey = getStoredServiceKey();

    const url = process.env.REACT_APP_TICKETS_ENDPOINT;
    if (!url) {
        console.error("getTickets: REACT_APP_TICKETS_ENDPOINT no está definida. Reinicia el servidor de desarrollo si acabas de agregar la variable al .env");
        return { error: "REACT_APP_TICKETS_ENDPOINT not defined" };
    }

    try {
        let res = await Axios({
            url: `${url}`,
            method: "GET",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in getTickets", res);
        return res;
    } catch (error) {
        process.env.REACT_APP_DEBUG === "true" && console.log("Catch error in getTickets", error);
        return error;
    }
}

//Update Ticket (actualizar estado, responsable y prioridad en una sola petición)
// - PATCH /whatsapp/tickets con:
//   { ticketId, status, assignedTo, priority }
async function updateTicket({ ticketId, status, assignedTo, priority, resolution, tags }) {
    const token = await getCampaignToken();
    if (!token) return { error: "No token" };
    const serviceKey = getStoredServiceKey();
    const url = process.env.REACT_APP_TICKETS_ENDPOINT;
    if (!url) return { error: "REACT_APP_TICKETS_ENDPOINT not defined" };

    // El payload depende de la transición (lo arma el modal). Solo se incluyen
    // los campos presentes:
    //   -> EN_PROCESO: { ticketId, status, assignedTo, priority }
    //   -> RESUELTO:   { ticketId, status, resolution }
    //   -> CERRADO:    { ticketId, status }
    //   tags (sin status): { ticketId, tags }
    const payload = { ticketId };
    if (status !== undefined) payload.status = status;
    if (assignedTo !== undefined) payload.assignedTo = assignedTo;
    if (priority !== undefined) payload.priority = priority;
    if (resolution !== undefined) payload.resolution = resolution;
    if (tags !== undefined) payload.tags = tags;

    try {
        let res = await Axios({
            url: `${url}`,
            method: "PATCH",
            timeout: 30000,
            headers: {
                "Content-Type": "application/json",
                Authorization: token,
                "x-access-key": serviceKey,
            },
            data: JSON.stringify(payload),
        });
        process.env.REACT_APP_DEBUG === "true" && console.log("Response in updateTicket", res);
        return res;
    } catch (error) {
        if (process.env.REACT_APP_DEBUG === "true") {
            console.log("Catch error in updateTicket", error);
            console.log("updateTicket status:", error?.response?.status);
            console.log("updateTicket body:", JSON.stringify(error?.response?.data));
            console.log("updateTicket payload enviado:", JSON.stringify(payload));
        }
        return error;
    }
}

//Notificación de ticket resuelto (envío de mensaje al cliente por WhatsApp)
// Usa el mismo servicio SendMessage que las campañas. La plantilla es fija;
// los demás datos dependen del ticket.
// Payload:
//   {
//     templateName: "plantilla_generar_ticket",
//     contacts: [ { phone, param1 (nombre), param2 (folio) } ],
//     email: <usuario logueado>
//   }
async function sendTicketResolvedNotification({ phone, name, folio }) {
    const remeberAuthCredentials = localStorage.getItem("remeberAuthCredentials");
    const email = remeberAuthCredentials
        ? localStorage.getItem("email")
        : sessionStorage.getItem("email");

    const data = {
        templateName: "plantilla_generar_ticket",
        contacts: [
            {
                phone: phone,
                param1: name,
                param2: folio,
            },
        ],
        email: email,
    };

    // Reutiliza el envío de mensajes (POST a SendMessage con token + x-access-key).
    return await sendMessageActions(data);
}
